<template>
  <div class="brand-logo">
    <img
      alt="Snapshot logo"
      src="~@/assets/logo.svg"
      class="max-h-7 rounded-md inline-block"
    />
  </div>
</template>
